/* eslint-disable consistent-return */
/* eslint-disable no-restricted-syntax */
/* eslint-disable no-restricted-globals */
/* eslint-disable camelcase */
/* eslint-disable no-param-reassign */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/prop-types */
import React, { useState, useEffect, useCallback, useMemo, useRef } from 'react';
import PropTypes from 'prop-types';
import { Box, Button, Card, Grid, Modal, SvgIcon, Typography } from '@material-ui/core';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import styled from 'styled-components';
import { AgGridReact } from 'ag-grid-react';
import { Check, Close, Refresh } from '@material-ui/icons';
import { green, red } from '@material-ui/core/colors';
import { bindActionCreators } from 'redux';
import cloneDeep from 'lodash/cloneDeep';
import { connect } from 'react-redux';
import store from '../../../redux/store';
import * as pricingActionsImport from '../../../redux/actions/pricing';
import {
  setGroupsOpenned,
  setGroupFocused,
  refreshInventory,
  refreshGroupedListings,
} from '../../../redux/actions/refresh-groups-inventory';
import HoverIconsBuilder from '../../../components/HoverIconsBuilder';
import ListingsTooltip from '../../../components/ListingsTooltip';
import 'ag-grid-enterprise';
import { isDef } from '../../../shared/utils/validations';
import '../../../styles/Tooltip.scss';
import { gridSort, getBadGroupsData, saveGroupChanges } from '../../../helpers/pricing';
import ValidateUser from '../../../components/UserStatus';
import NewGroupModal from '../../../components/CreateGroupModal';
import {
  refreshGroups,
  updateGroupFields,
  setPushEnableAction,
  setGroupsAction,
  removeMarketplace,
} from '../../../redux/actions/refresh-groups';
import {
  setListingRows,
  setDeleteGroupModalOpen,
  setDeletedGroupName,
  setBadGroups,
} from '../../../redux/actions/groups';
import { deletePricingGroup } from '../../../services/killshot';
import { ReactComponent as BarcodeDisabledIcon } from '../../../images/pricing/barcode-disabled.svg';
import { ReactComponent as BarcodeIcon } from '../../../images/pricing/barcode.svg';
import { formatToCurrency } from '../../../helpers/number';

const EMPTY_STRING = '';
const DEBOUNCE_DELAY = 50;

const coloredLine = {
  content: '""',
  position: 'relative',
  bottom: 0,
  left: 0,
  width: '100%',
  height: '1px', // Height of the line
};
const transferListingButton = {
  width: '82px',
  height: '32px',
  marginTop: '12px',
  paddingTop: '9px',
  fontSize: '14px',
  fontWeight: '700',
  lineHeight: '18.62px',
};
const subMenuTransferTo = {
  fontSize: '12px',
  lineHeight: '15.96px',
  fontWeight: '600',
};
const styles = makeStyles(theme => ({
  button: {
    width: '100%',
    marginTop: '10px',
  },
  paper: {
    position: 'absolute',
    width: theme.spacing(50),
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    padding: theme.spacing(4),
    outline: 'none',
  },
  transferListingModal: {
    position: 'absolute',
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    outline: 'none',
  },

  listingTransferModalLightTheme: { color: '#9C27B0' },
  listingTransferModalDarkTheme: { color: '#E1BEE7' },
  lineTexLightColor: { ...coloredLine, backgroundColor: '#7D7D7D' },
  lineTexDarkColor: { ...coloredLine, backgroundColor: '#5C5C5C' },
  lineLightTheme: {
    ...coloredLine,
    backgroundColor: '#9C27B0',
  },
  lineDarkTheme: {
    ...coloredLine,
    backgroundColor: '#E1BEE7',
  },
  buttonTransfLightTheme: {
    ...transferListingButton,
    color: '#9C27B0',
    borderColor: '#9C27B0',
  },
  buttonTransfDarkTheme: {
    ...transferListingButton,
    color: '#BA68C8',
    borderColor: '#BA68C8',
  },
  subMenuTransferLight: {
    ...subMenuTransferTo,
    color: '#515151',
  },
  subMenuTransferDark: {
    ...subMenuTransferTo,
    color: '#D4D4D4',
  },
  subMenuStyle: {
    fontSize: '12px',
    '& .ag-menu-option-text': {
      maxWidth: '215px',
      width: '215px',
      padding: '0px 10px 0px 0px',
      whiteSpace: 'pre-wrap',
    },
    '& .ag-menu-option-icon': {
      width: '8px',
    },
  },
  customSubmenuOptionDisabled: {
    fontSize: '10px',
    '&.ag-menu-option-disabled': {
      opacity: 1,
    },
    '& .ag-menu-option-text': {
      padding: '0px 8px 10px 0px',
    },
    '& .ag-menu-option-icon': {
      width: '8px',
    },
  },
  nonSelectableOption: {
    fontSize: '12px',
    pointerEvents: 'none',
    '&:hover': {
      backgroundColor: 'transparent !important',
    },
    '& .ag-menu-option-text': {
      padding: '0px 8px 10px 0px',
    },
  },
  menuOptionsStyle: {
    '& .ag-menu-option-popup-pointer': {
      '&::before': {
        content: '"\\002B"',
        paddingLeft: '1px',
        fontSize: '18px',
        fontWeight: '350',
      },
    },
  },
}));

const BroadcastContainer = styled.div`
  display: flex;
  justify-content: space-around;
  width: 150px;
`;

const FIFTY = 50;
const TEN = 10;
const ModalContainer = styled.div`
  top: ${FIFTY}%;
  left: ${FIFTY}%;
  transform: translate(-${FIFTY}%, -${FIFTY}%);
  h2,
  h3 {
    margin-bottom: ${TEN}px;
  }
`;

const PricingGroupRanks = props => {
  const {
    filteredMarketplaceListings,
    showTMRListPrice,
    tmrMarkUpDown,
    shMarkUpDown,
    showSHListPrice,
    vsMarkUpDown,
    showVSListPrice,
  } = props;
  const renderBroadcast = ({ data }) => (
    <BroadcastContainer>
      {data && data?.broadcast ? <Check style={{ color: green[500] }} /> : <Close style={{ color: red[500] }} />}
    </BroadcastContainer>
  );

  const renderBroadcast2 = ({ data }) => {
    if (props && data) {
      if (props.activeMarketplace) {
        if (props.activeMarketplace === 'ticketnetwork' || props.activeMarketplace === 'stubhub') {
          if (data?.ticketnetwork_broadcast_status === 1) return <Check style={{ color: green[500] }} />;
          if (data?.ticketnetwork_broadcast_status >= 2 && data?.ticketnetwork_broadcast_status <= 4)
            return <Refresh />;
          if (data?.ticketnetwork_broadcast_status >= 5) return <Close style={{ color: red[500] }} />;
        } else if (props.activeMarketplace === 'seatgeek') {
          if (data?.seatgeek_broadcast_status === 1) return <Check style={{ color: green[500] }} />;
          if (data?.seatgeek_broadcast_status >= 2 && data?.seatgeek_broadcast_status <= 4) return <Refresh />;
          if (data?.seatgeek_broadcast_status >= 5 || data?.seatgeek_broadcast_status === 0)
            return <Close style={{ color: red[500] }} />;
        }
      }
    }
    return '';
  };

  const renderListPrice = ({ data }) => {
    const barcodeValidated = data?.barcode_error !== null && data?.barcode_error !== undefined;
    const barcodeEnabled = data?.barcode_error === 0;
    return (
      <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px', fontVariantNumeric: 'tabular-nums' }}>
        {data?.list_price ? formatToCurrency(data.list_price) : ''}
        {barcodeValidated && barcodeEnabled ? <SvgIcon component={BarcodeIcon} viewBox="0 0 19 13" /> : null}
        {barcodeValidated && !barcodeEnabled ? <SvgIcon component={BarcodeDisabledIcon} viewBox="0 0 20 13" /> : null}
      </Box>
    );
  };

  let columnDefs = useMemo(
    () => [
      {
        headerName: '',
        field: 'skybox_id',
        pinned: 'left',
        filter: 'agTextColumnFilter',
        checkboxSelection: true,
        headerCheckboxSelection: true,
        suppressMenu: true,
        resizable: true,
        rowDrag: true,
        sortable: true,
        cellRendererFramework: ({ data }) => {
          if (data !== undefined) {
            return null;
          }
          return <img alt="loading" src="https://www.ag-grid.com/example-assets/loading.gif" />;
        },
        initialWidth: 68,
      },
      {
        headerName: 'Section',
        field: 'section',
        filter: 'agTextColumnFilter',
        suppressMenu: true,
        resizable: true,
        cellRendererFramework: ListingsTooltip,
        sortable: true,
        flex: 1,
      },
      {
        headerName: 'Rows',
        field: 'rows',
        filter: 'agTextColumnFilter',
        suppressMenu: true,
        resizable: true,
        cellRendererFramework: ListingsTooltip,
        sortable: true,
        comparator: (a, b) => {
          if (!Number.isNaN(Number(a)) && Number.isNaN(Number(b))) return -1;
          if (Number.isNaN(Number(a)) && !Number.isNaN(Number(b))) return 1;
          if (Number.isNaN(Number(a)) && Number.isNaN(Number(b))) {
            if (a.length === b.length) return a > b ? 1 : -1;
            return a.length > b.length ? 1 : -1;
          }

          return a - b;
        },
        flex: 1,
      },
      {
        headerName: 'Seats',
        field: 'seats',
        filter: 'agTextColumnFilter',
        suppressMenu: true,
        resizable: true,
        cellRendererFramework: ListingsTooltip,
        sortable: true,
        flex: 1,
      },
      {
        headerName: 'Qty',
        field: 'quantity',
        filter: 'agDateColumnFilter',
        suppressMenu: true,
        resizable: true,
        cellRendererFramework: ListingsTooltip,
        sortable: true,
        flex: 0.75,
      },
      {
        headerName: 'Properties',
        field: 'deliveryMethod',
        filter: 'agSetColumnFilter',
        resizable: true,
        cellRendererFramework: HoverIconsBuilder,
        sortable: true,
        cellStyle: {
          display: 'inline-grid',
          justifyContent: 'center',
        },
        flex: 1,
      },
      {
        headerName: 'Cost',
        field: 'cost',
        filter: 'agDateColumnFilter',
        suppressMenu: true,
        resizable: true,
        cellRendererFramework: ListingsTooltip,
        comparator: (valueA, valueB) => {
          const valueA_number = parseFloat(valueA.replace('$', ''));
          const valueB_number = parseFloat(valueB.replace('$', ''));
          const comparison = valueA_number - valueB_number;
          return comparison;
        },
        sortable: true,
        flex: 1,
      },
      {
        headerName: 'List Price',
        field: 'list_price',
        filter: 'agTextColumnFilter',
        suppressMenu: true,
        resizable: true,
        cellRendererFramework: renderListPrice,
        sortable: true,
        flex: 1.5,
      },
      {
        headerName: 'TMR List Price',
        field: 'tmr_list_price',
        suppressMenu: true,
        resizable: true,
        cellRendererFramework: ListingsTooltip,
        sortable: true,
        hide: !showTMRListPrice || !tmrMarkUpDown || tmrMarkUpDown < 0,
        minWidth: 70,
        flex: 1,
      },
      {
        headerName: 'SH List Price',
        field: 'sh_list_price',
        suppressMenu: true,
        resizable: true,
        cellRendererFramework: ListingsTooltip,
        sortable: true,
        hide: !showSHListPrice || !shMarkUpDown || shMarkUpDown < 0,
        minWidth: 70,
        flex: 1,
      },
      {
        headerName: 'VS List Price',
        field: 'vs_list_price',
        suppressMenu: true,
        resizable: true,
        cellRendererFramework: ListingsTooltip,
        sortable: true,
        hide: !showVSListPrice || !vsMarkUpDown || vsMarkUpDown < 0,
        minWidth: 70,
        flex: 1,
      },
      {
        headerName: 'Calculated Price',
        field: 'calculated_price',
        suppressMenu: true,
        resizable: true,
        cellRendererFramework: ListingsTooltip,
        comparator: (valueA, valueB) => {
          const valueA_number = parseFloat(valueA);
          const valueB_number = parseFloat(valueB);
          const comparison = valueA_number - valueB_number;
          return comparison;
        },
        sortable: true,
        flex: 1,
      },
      {
        headerName: 'Sent to POS',
        field: 'broadcast',
        resizable: true,
        autoHeight: true,
        cellRendererFramework: renderBroadcast,
        cellStyle: {
          display: 'inline-grid',
          justifyContent: 'center',
        },
        flex: 1,
      },
      {
        headerName: 'Broadcasted',
        field: 'skybox_broadcast_status',
        resizable: true,
        autoHeight: true,
        cellRendererFramework: renderBroadcast2,
        cellStyle: {
          display: 'inline-grid',
          justifyContent: 'center',
        },
        flex: 1,
      },
    ],
    [
      props.activeMarketplace,
      tmrMarkUpDown,
      shMarkUpDown,
      vsMarkUpDown,
      showTMRListPrice,
      showSHListPrice,
      showVSListPrice,
    ]
  );

  const getColumns = () => {
    const { isAbTest } = props;
    if (isAbTest) {
      columnDefs = columnDefs.filter(column => {
        return column.field !== 'cost';
      });
    }

    return columnDefs;
  };

  const firstGroupTagsToCheck = ['nontransferable_rotating'];

  const initialState = {
    rows: [],
    dataReady: false,
    selectedRows: [],
    openModal: false,
    disableDeleteListings: true,
    showTooltip: false,
    focusedPricingGroup: null,
    groupId: props.groupId,
    getRowStyle: params => {
      if (params?.data?.hold) {
        return { background: '#B71C1C', border: '1px solid #696969' };
      }
      if (isDef(params?.data) && params?.data?.qcStatus) {
        return { background: '#F9A825', border: '1px solid #696969' };
      }
      if (params && params.data && params.data.tags) {
        if (firstGroupTagsToCheck.some(t => params.data.tags.includes(t))) {
          return { background: '#ff66cc', border: '1px solid #696969' };
        }
      }
      return false;
    },
  };

  const initialTransferState = {
    selectedRows: [],
  };

  const [state, setState] = useState(initialState);
  const [initPosition, setInitPosition] = useState([]);
  const [sortInfo, setSortInfo] = useState({ type: '', col: '' });
  const [rows2, setRows2] = useState([]);
  const [dataRows, setDataRows] = useState([]);
  const [gridApi, setGridApi] = useState({});
  const gridRef = useRef(null);
  const timeoutRef = useRef(null);
  const classes = styles();
  const theme = useTheme();
  const [showModal, setShowModal] = useState(false);
  const [transferGroupName, setTransferGroupName] = useState('');
  const [transferState, setTransferState] = useState(initialTransferState);
  const [transferIndexState, setTransferIndexState] = useState(undefined);
  const [currGroupName, setCurrGroupName] = useState('');
  const [isLoading, seIsLoading] = useState(false);
  const [createGroupSaveButtonDisabled, setCreateGroupSaveButtonDisabled] = useState(false);

  const percentage = (totalValue, totalPercentage) => (totalValue * totalPercentage) / 100;

  const { groupName, setUpdateListingsOnSave, isModalOpen, currCompSections, setIsModalOpen } = props;

  const updateListingsRows = (newValue, groupId) => {
    store.dispatch(setListingRows(newValue));
    const actualGroup = store.getState().refreshGroups.groups.find(g => g.id === groupId);
    const newActualGroupValue = newValue.find(ng => ng.groupId === groupId);
    if (actualGroup && newActualGroupValue) {
      const ranks = actualGroup.ranks.map(r => {
        return r.skybox_listing_id;
      });
      const stateRanks = newActualGroupValue.rows.map(r => {
        return r.skybox_listing_id;
      });
      const hasChanged =
        Array.isArray(ranks) && Array.isArray(stateRanks) && JSON.stringify(ranks) !== JSON.stringify(stateRanks);
      const fieldInfo = { enablePush: true, hasChanged };
      const { newGroupFieldsToUpdate, pushEnableUpdateValue } = saveGroupChanges(
        groupId,
        fieldInfo,
        store.getState().refreshGroups.isPushEnable,
        'ranks',
        store.getState().refreshGroups.groupFields,
        null,
        null
      );
      if (Object.keys(newGroupFieldsToUpdate).length > 0) {
        store.dispatch(updateGroupFields(newGroupFieldsToUpdate));
      }
      store.dispatch(setPushEnableAction(pushEnableUpdateValue));
    }
  };

  const updateState = newState => {
    const idx = store.getState().groups.listingRows.findIndex(l => l.groupId === props.groupId);
    if (idx > -1) {
      const newListingRows = store.getState().groups.listingRows;
      newListingRows[idx] = { ...newState };
      updateListingsRows(newListingRows, props.groupId);
    }
  };

  const getCalculatedPrices = () => {
    const {
      increment,
      floor,
      ceiling,
      manualPrice,
      incrementType,
      spaceout,
      spaceoutType,
      ranks,
      groupedListings,
      group,
      settings,
      isCompAllEvent,
    } = props;
    const groupListingRows = store.getState().groups.listingRows.find(l => l.groupId === group.id);
    let groupRanks = ranks;
    const { type, col } = sortInfo;
    if (typeof groupListingRows !== 'undefined' && ((type !== '' && col !== '') || state.drag)) {
      groupRanks = groupListingRows.rows;
    }
    const anchor = groupedListings.find(gl => gl.skybox_id === groupRanks[0].skybox_listing_id) || {
      list_price: 0,
      skybox_id: null,
    };
    const calculatedPrices = {};
    let anchorPrice = 0;
    let minPrice = 0;
    let anchorId = 0;
    let listPrice = 0;
    let skyboxId = 0;

    const currComps = currCompSections;
    if (currComps.length || isCompAllEvent || group.comp_all) {
      if (filteredMarketplaceListings.length) {
        if (settings.response.marketplace_listing_id === 'Broker ID') {
          // eslint-disable-next-line prefer-destructuring
          minPrice = filteredMarketplaceListings
            .filter(sh => !sh.is_reps)
            .map(sl => Number(sl.total_price?.slice(1)?.replace(/[, ]+/g, '')))
            .sort((a, b) => Number(a) - Number(b))[0];
        } else {
          // eslint-disable-next-line prefer-destructuring
          minPrice = filteredMarketplaceListings
            .filter(sh => !sh.is_ours)
            .map(sl => Number(sl.total_price?.slice(1)?.replace(/[, ]+/g, '')))
            .sort((a, b) => Number(a) - Number(b))[0];
        }
        if (incrementType === '%') {
          anchorPrice = minPrice * (1 + increment / 100);
        } else {
          anchorPrice = Number(minPrice) + Number(increment);
        }
      } else {
        anchorPrice = manualPrice || ceiling || anchor.list_price;
      }
      anchorPrice = parseFloat(parseInt(anchorPrice * 100, 10) / 100);
      if (ceiling) {
        anchorPrice = Math.min(anchorPrice, ceiling);
      }

      anchorPrice = Math.max(anchorPrice, floor);
      const { has_dynamic_spaceout: hasDynamicSpaceout } = group;
      let listingsStart = 0;
      if (!hasDynamicSpaceout) {
        listingsStart = 1;
        if (anchorPrice !== anchor.list_price) {
          anchorId = anchor.skybox_id;
          calculatedPrices[anchorId] = anchorPrice;
        } else {
          anchorId = anchor.skybox_id;
          calculatedPrices[anchorId] = anchor.list_price;
        }
      }
      const listings = [];
      groupRanks.forEach(r => {
        const match = groupedListings.find(gl => gl.skybox_id === r.skybox_listing_id);
        if (typeof match !== 'undefined') {
          match.dynamic_spaceout = r.dynamic_fx;
          match.aisle_markup = r.aisle_markup || 0;
          listings.push(match);
        }
      });
      for (let i = listingsStart; i < listings.length; i += 1) {
        const idx = i - 1;
        const dynamicSpaceout = listings[i].dynamic_spaceout;
        const aisleMarkup = listings[i].aisle_markup || 0;
        // Apply dynamic spaceout adjustment
        if (dynamicSpaceout !== null && group.dynamic_spaceout_enabled) {
          listPrice = (anchorPrice + anchorPrice * dynamicSpaceout) * (1 + aisleMarkup);
        } else if (spaceoutType === '$') {
          listPrice = anchorPrice + spaceout * (idx + 1);
        } else {
          listPrice = percentage(anchorPrice, 100 + spaceout * (idx + 1));
        }

        listPrice = Number(listPrice.toFixed(2));
        if (listPrice !== listings[i].list_price || hasDynamicSpaceout) {
          skyboxId = listings[i].skybox_id;
          calculatedPrices[skyboxId] = listPrice;
        } else {
          skyboxId = listings[i].skybox_id;
          calculatedPrices[skyboxId] = listings[i].list_price;
        }
      }
    } else {
      const listings = [];
      groupRanks.forEach(r => {
        const match = groupedListings.find(gl => gl.skybox_id === r.skybox_listing_id);
        if (typeof match !== 'undefined') {
          match.dynamic_spaceout = r.dynamic_fx;
          match.aisle_markup = r.aisle_markup || 0;
          listings.push(match);
        }
      });

      if (!listings.length) return calculatedPrices;
      calculatedPrices[listings[0].skybox_id] = manualPrice;
      for (let i = 1; i < listings.length; i += 1) {
        const idx = i - 1;
        const mprice = Number(manualPrice || 0);
        let res = 0;
        const dynamicSpaceout = listings[i].dynamic_spaceout;
        const aisleMarkup = listings[i].aisle_markup || 0;
        if (dynamicSpaceout) {
          listPrice = (anchorPrice + anchorPrice * dynamicSpaceout) * (1 + aisleMarkup);
        } else if (spaceoutType === '$') {
          res = mprice + spaceout * (idx + 1);
        } else {
          res = percentage(mprice, 100 + spaceout * (idx + 1));
        }

        skyboxId = listings[i].skybox_id;
        calculatedPrices[skyboxId] = res;
      }
    }

    return calculatedPrices;
  };

  const MapRows = groupRanks => {
    const { groupedListings, hashBroadcast } = props;
    const calculatedPrice = '--';
    const rows = groupRanks.map(rank => {
      const groups = groupedListings
        .filter(o => o.skybox_id === rank.skybox_listing_id)
        .map(matchedListing => {
          return {
            skybox_id: matchedListing.skybox_id.toString(),
            list_price: matchedListing.list_price,
            calculated_price: calculatedPrice,
            broadcast: hashBroadcast[matchedListing.skybox_id],
            section: matchedListing.section,
            rows:
              matchedListing.rows.length > 5
                ? `${matchedListing.rows.slice(0, 5).join(', ')}...`
                : matchedListing.rows.join(', '),
            quantity: matchedListing.quantity,
            cost: `$${matchedListing.cost.per_unit}`,
            tags: matchedListing.tags,
            held: matchedListing.held,
            hold: matchedListing.hold,
            qcStatus: !!matchedListing.tags.find(t => t === 'qc'),
            seats: `${matchedListing.seats.low} - ${matchedListing.seats.high}`,
            public_notes: matchedListing.notes.public,
            deliveryMethod: matchedListing.delivery_method,
            skybox_listing_id: rank.skybox_listing_id,
            skybox_broadcast_status: matchedListing.skybox_broadcast_status,
            stubhub_broadcast_status: matchedListing.stubhub_broadcast_status,
            ticketnetwork_broadcast_status: matchedListing.ticketnetwork_broadcast_status,
            seatgeek_broadcast_status: matchedListing.seatgeek_broadcast_status,
          };
        });
      return groups[0];
    });
    return rows;
  };

  const createRows = () => {
    const { ranks, groupedListings, hashBroadcast, isFocused, groupId, pricingGroup } = props;
    // eslint-disable-next-line no-debugger
    // debugger;
    const calculatedPrices = isFocused ? getCalculatedPrices() : {};
    let calculatedPrice = '--';
    const { type, col } = sortInfo;
    const hasDynamicSpaceout = pricingGroup.has_dynamic_spaceout;
    const groupListingRows = store.getState().groups.listingRows.find(l => l.groupId === groupId);
    let groupRanks = ranks;
    if (typeof groupListingRows !== 'undefined' && ((type !== '' && col !== '') || state.drag)) {
      groupRanks = groupListingRows.rows;
    }
    let rows = groupRanks.map(rank => {
      const { dynamic_fx, aisle_markup } = rank;
      const groups = groupedListings
        .filter(o => o.skybox_id === rank.skybox_listing_id)
        .map(matchedListing => {
          if (isFocused) {
            calculatedPrice = Number(calculatedPrices[matchedListing.skybox_id] || 0).toFixed(2);
          }

          return {
            skybox_id: matchedListing.skybox_id.toString(),
            list_price: matchedListing.list_price,
            tmr_list_price: `$ ${(
              matchedListing.list_price +
              matchedListing.list_price * (tmrMarkUpDown / 100)
            ).toFixed(2)}`,
            sh_list_price: `$ ${(matchedListing.list_price + matchedListing.list_price * (shMarkUpDown / 100)).toFixed(
              2
            )}`,
            vs_list_price: `$ ${(matchedListing.list_price + matchedListing.list_price * (vsMarkUpDown / 100)).toFixed(
              2
            )}`,
            calculated_price: calculatedPrice,
            dynamic_fx,
            aisle_markup,
            has_dynamic_spaceout: hasDynamicSpaceout,
            broadcast: hashBroadcast[matchedListing.skybox_id],
            section: matchedListing.section,
            rows:
              matchedListing.rows.length > 5
                ? `${matchedListing.rows.slice(0, 5).join(', ')}...`
                : matchedListing.rows.join(', '),
            quantity: matchedListing.quantity,
            cost: `$${matchedListing.cost.per_unit}`,
            tags: matchedListing.tags,
            held: matchedListing.held,
            hold: matchedListing.hold,
            qcStatus: !!matchedListing.tags.find(t => t === 'qc'),
            seats: `${matchedListing.seats.low} - ${matchedListing.seats.high}`,
            public_notes: matchedListing.notes.public,
            deliveryMethod: matchedListing.delivery_method,
            skybox_listing_id: rank.skybox_listing_id,
            skybox_broadcast_status: matchedListing.skybox_broadcast_status,
            stubhub_broadcast_status: matchedListing.stubhub_broadcast_status,
            ticketnetwork_broadcast_status: matchedListing.ticketnetwork_broadcast_status,
            seatgeek_broadcast_status: matchedListing.seatgeek_broadcast_status,
            include_exclude: rank.include_exclude,
            barcode_error: matchedListing.barcode_error,
          };
        });
      return groups[0];
    });
    if (type !== '' && col !== '') {
      const rowsTmp = rows;
      rows = gridSort(rowsTmp, col, type);
    }
    const newRows = JSON.parse(JSON.stringify(rows.filter(r => typeof r !== 'undefined')));
    const newRows2 = JSON.parse(JSON.stringify(rows.filter(r => typeof r !== 'undefined')));

    setRows2(newRows2);
    setState({ ...state, rows: newRows, dataReady: true });
    const groupIdx = store.getState().groups.listingRows.findIndex(l => l.groupId === props.groupId);
    if (groupIdx === -1) {
      const newListingRows = store.getState().groups.listingRows;
      newListingRows.push({ ...state, rows: newRows, dataReady: true });
      updateListingsRows(newListingRows, props.groupId);
    } else {
      const newListingRows = store.getState().groups.listingRows;
      newListingRows[groupIdx] = { ...state, rows: newRows, dataReady: true };
      updateListingsRows(newListingRows, props.groupId);
    }
    return rows;
  };

  const handleModalClose = e => {
    try {
      e.stopPropagation();
    } catch (error) {
      // Do nothing
    }

    setState({
      ...state,
      openModal: false,
    });
  };

  const handleDeleteGroup = async (groupId, skipRefreshGroup) => {
    const { skyboxId, pricingActions } = props;
    await deletePricingGroup(groupId);
    if (!skipRefreshGroup) {
      await store.dispatch(refreshGroups(skyboxId, true, groupId));
      pricingActions.setFocusedPricingGroupSection(null);
      store.dispatch(removeMarketplace(groupId));
      store.dispatch(refreshGroupedListings(skyboxId));
      store.dispatch(refreshInventory(skyboxId));
    }
  };

  const callbackUpdateListings = async (newRows, index, skipRefreshGroup = false) => {
    const { skyboxId, pricingActions, typeListing } = props;
    // eslint-disable-next-line prefer-destructuring
    const zones = store.getState().zones;
    // eslint-disable-next-line prefer-destructuring
    const selectedGroup = store.getState().pricing.selectedGroup;
    const pricingGroup = store.getState().refreshGroups.groups[index];
    const groupData = [
      {
        ...pricingGroup,
        skybox_event_id: skyboxId,
        ranks: newRows.map((row, i) => ({
          rank: i,
          skybox_listing_id: row.skybox_listing_id,
          include_exclude: pricingGroup.ranks.find(r => r.skybox_listing_id === row.skybox_listing_id).include_exclude,
        })),
      },
    ];
    props.pricingActions.setGroupEditingId(groupData[0].id);
    if (!groupData[0].ranks.length) {
      await handleDeleteGroup(groupData[0].id, skipRefreshGroup);
    } else {
      if (typeListing === 'stubhub') {
        await pricingActionsImport.savePricingGroup(skyboxId, groupData, false, currCompSections, zones);
      } else {
        const comps = {};
        comps[typeListing] = store.getState().pricing.currTNComparisonSections;
        await pricingActionsImport.savePricingGroup(
          skyboxId,
          groupData,
          false,
          comps,
          zones,
          typeListing,
          false,
          null,
          null,
          true
        );
      }
      if (!skipRefreshGroup) {
        await store.dispatch(refreshGroups(skyboxId));
      }
      pricingActions.setGroup({
        ...selectedGroup,
        ranks:
          selectedGroup.ranks &&
          selectedGroup.ranks.filter(rank => newRows.find(row => row.skybox_listing_id === rank.skybox_listing_id)),
      });
      pricingActions.setGroupEditingId(-1);
    }
    if (!skipRefreshGroup) {
      store.dispatch(refreshInventory(skyboxId));
      store.dispatch(refreshGroupedListings(skyboxId));
    }
  };

  const callbackUpdateReArrange = (newRows, index) => {
    const newGroups = cloneDeep(store.getState().refreshGroups.groups);
    const { marketplaces } = props;
    if (marketplaces) {
      const mplaces = Object.keys(marketplaces)
        .filter(key => {
          const value = marketplaces[key].value.split('_')[1];
          const prefix = value[0];
          return prefix === '+' || prefix === '-';
        })
        .map(key => marketplaces[key].value.split('_')[1]);

      newGroups[index].ranks = newRows.map((row, i) => ({
        rank: i + 1,
        skybox_listing_id: row.skybox_listing_id,
        include_exclude: mplaces,
      }));
      store.dispatch(setGroupsAction(newGroups));
    }
  };

  const handleSnackBarOpen = () => {
    store.dispatch(setDeleteGroupModalOpen(true));
  };

  const callbackUpdateTransferListings = async (
    currGroupIndex,
    currGroupListings,
    transfGroupIndex,
    tranfGroupListings,
    compData
  ) => {
    const { skyboxId } = props;
    const groupFrom = store.getState().refreshGroups.groups[currGroupIndex];
    const groupTo = store.getState().refreshGroups.groups[transfGroupIndex];
    const groupDataFrom = [
      {
        ...groupFrom,
        skybox_event_id: skyboxId,
        ranks: currGroupListings.map((row, i) => ({
          rank: i,
          skybox_listing_id: row.skybox_listing_id,
          include_exclude: groupFrom.ranks.find(r => r.skybox_listing_id === row.skybox_listing_id).include_exclude,
        })),
      },
    ];

    const groupDataTo = [
      {
        ...groupTo,
        skybox_event_id: skyboxId,
        ranks: tranfGroupListings.map((row, i) => ({
          rank: i,
          skybox_listing_id: row.skybox_listing_id,
          include_exclude: groupTo.ranks[0].include_exclude ? groupTo.ranks[0].include_exclude : [],
        })),
      },
    ];
    const marketplaceActive = store.getState().groupsStubhubState.activeMarketplaces
      ? store.getState().groupsStubhubState.activeMarketplaces[0]
      : 'ticketnetwork';
    if (!currGroupListings.length) {
      await deletePricingGroup(groupDataFrom[0].id, true, groupTo.id);
      store.dispatch(setDeletedGroupName(groupDataFrom[0].name));
    } else {
      await pricingActionsImport.savePricingGroup(
        skyboxId,
        groupDataFrom,
        false,
        compData.compsFrom,
        [],
        marketplaceActive,
        true,
        groupFrom,
        groupTo,
        true
      );
    }
    await pricingActionsImport.savePricingGroup(
      skyboxId,
      groupDataTo,
      false,
      compData.compsTo,
      [],
      marketplaceActive,
      true,
      groupFrom,
      groupTo,
      true
    );
    const newGroups = await store.dispatch(refreshGroups(skyboxId));
    store.dispatch(setBadGroups(getBadGroupsData(newGroups)));

    if (!currGroupListings.length) {
      handleSnackBarOpen();
    }
  };

  const deleteListingConfirmed = e => {
    try {
      e.stopPropagation();
    } catch (error) {
      // Do nothing
    }

    const { selectedRows } = state;

    if (selectedRows.length > 0) {
      const { index } = props;

      const newRows = rows2.filter((r, i) => {
        let flag = true;
        selectedRows.forEach(s => {
          if (s.rowIndex === i) {
            flag = false;
          }
        });
        return flag;
      });
      callbackUpdateListings(newRows, index);
      callbackUpdateReArrange(newRows, index);
      setState({ ...state, selectedRows: [] });
      handleModalClose();
    }
  };

  const createNewGroupHandler = params => {
    const selectedRows = params.api.getSelectedNodes();

    if (selectedRows.length > 0) {
      const se = selectedRows.map(s => ({
        rowIndex: s.rowIndex,
      }));

      setState({ ...state, selectedRows: JSON.parse(JSON.stringify(se)) });
    }
    setIsModalOpen(true);
  };

  const deleteListingHandler = params => {
    const selectedRows = params.api.getSelectedNodes();

    if (selectedRows.length > 0) {
      const se = selectedRows.map(s => ({
        rowIndex: s.rowIndex,
      }));

      setState({ ...state, openModal: true, selectedRows: JSON.parse(JSON.stringify(se)) });
    }
  };
  const handleSubMenuClick = (groupNameToTransfer, gindex, params) => {
    setTransferIndexState(gindex);
    setTransferGroupName(groupNameToTransfer);
    const selectedRows = params.api.getSelectedNodes();
    if (selectedRows.length > 0) {
      const se = selectedRows.map(s => ({
        rowIndex: s.rowIndex,
      }));

      setTransferState({ ...transferState, selectedRows: JSON.parse(JSON.stringify(se)) });
    }
    setShowModal(true);
  };

  const handleSubMenuModalClose = () => {
    setShowModal(false);
  };

  const handleSubMenuModalConfirm = () => {
    const { index } = props;
    const { selectedRows } = transferState;
    const newRowsFromTransfer = rows2.filter((r, i) => {
      let flag = true;
      selectedRows.forEach(s => {
        if (s.rowIndex === i) {
          flag = false;
        }
      });
      return flag;
    });
    let newRowsToTransfer = rows2.filter((r, i) => {
      let flag = false;
      selectedRows.forEach(s => {
        if (s.rowIndex === i) {
          flag = true;
        }
      });
      return flag;
    });

    const currentGroupToTransferListings = MapRows(store.getState().refreshGroups.groups[transferIndexState].ranks);
    newRowsToTransfer = currentGroupToTransferListings.concat(newRowsToTransfer);
    const compData = {
      compsFrom: {
        ticketnetwork: store.getState().refreshGroups.groups[index].tnd_sections,
        seatgeek: store.getState().refreshGroups.groups[index].sg_sections,
      },
      compsTo: {
        ticketnetwork: store.getState().refreshGroups.groups[transferIndexState].tnd_sections,
        seatgeek: store.getState().refreshGroups.groups[transferIndexState].sg_sections,
      },
    };
    callbackUpdateTransferListings(
      index,
      newRowsFromTransfer,
      transferIndexState,
      newRowsToTransfer,
      compData,
      sortInfo
    );
    setShowModal(false);
  };

  const onGridReady = useCallback(params => {
    const { api } = params;
    setGridApi(api);
  }, []);

  const onSelectionChanged = () => {
    const selectedRows = gridApi.getSelectedNodes();
    const se = selectedRows.map(s => ({
      rowIndex: s.rowIndex,
    }));
    setState({ ...state, selectedRows: JSON.parse(JSON.stringify(se)) });
  };

  const onRowDragEnd = e => {
    const newRows = [];
    const set = new Set();
    e.api.forEachNode(node => {
      if (!set.has(node?.data?.skybox_id)) {
        newRows.push(node.data);
        set.add(node.data.skybox_id);
      }
    });

    const newRowsID = newRows.map(r => r.skybox_id);
    const hash = props.ranks.reduce((acum, curr) => {
      // eslint-disable-next-line no-param-reassign
      acum[curr.skybox_listing_id] = {
        ...curr,
      };
      return acum;
    }, {});

    const newRanks = [];
    const reverseRows = newRowsID.reverse();

    let counter = 1;
    while (reverseRows.length) {
      const id = reverseRows.pop();
      newRanks.push({ ...hash[id], rank: counter });
      counter += 1;
    }
    updateState({ ...state, rows: newRows });
    setState({ ...state, rows: newRows, drag: true });
    setUpdateListingsOnSave(null);
  };

  const onDragStopped = e => {
    const newRows = [];
    const set = new Set();
    e.api.forEachNode(node => {
      if (!set.has(node?.data?.skybox_id)) {
        newRows.push(node.data);
        set.add(node.data.skybox_id);
      }
    });

    const newRowsID = newRows.map(r => r.skybox_id);
    const hash = props.ranks.reduce((acum, curr) => {
      // eslint-disable-next-line no-param-reassign
      acum[curr.skybox_listing_id] = {
        ...curr,
      };
      return acum;
    }, {});

    const newRanks = [];
    const reverseRows = newRowsID.reverse();

    let counter = 1;
    while (reverseRows.length) {
      const id = reverseRows.pop();
      newRanks.push({ ...hash[id], rank: counter });
      counter += 1;
    }
    setState({ ...state, rows: newRows, drag: true });
    updateState({ ...state, rows: newRows });
  };

  const getContextMenuItems = params => {
    const selectedRows = params.api.getSelectedNodes();
    const { groupId } = props;
    const groupsFiltered = store.getState().refreshGroups.groups.filter(group => groupId !== group.id);
    // eslint-disable-next-line prefer-destructuring
    const selectedGroup = store.getState().pricing.selectedGroup;
    const { internal_notes_validation: internalNotesValidation } = selectedGroup;
    const transferDisabled = internalNotesValidation === 'PENDING';
    const subMenuOptions = groupsFiltered.map((group, index) => [
      {
        name: group.name,
        action: () => {
          handleSubMenuClick(group.name, store.getState().refreshGroups.groups.indexOf(group), params);
        },
        cssClasses: [classes.subMenuStyle],
      },
      index < groupsFiltered.length - 1 ? 'separator' : null,
    ]);
    const options = [
      {
        name: 'Transfer to existing group',
        subMenu: [
          {
            name: 'Transfer to',
            disabled: true,
            cssClasses: [classes.customSubmenuOptionDisabled],
          },
          ...subMenuOptions.flat(),
        ],
        disabled: !selectedRows.length || !groupsFiltered.length || transferDisabled,
      },
      'separator',
      {
        name: 'Transfer to new group',
        action: () => {
          createNewGroupHandler(params);
        },
        disabled: !selectedRows.length || transferDisabled,
        cssClasses: [classes.menuOptionsStyle],
      },
      'separator',
      {
        name: 'Remove Selected Listings',
        action: () => {
          deleteListingHandler(params);
        },
        disabled: !selectedRows.length || transferDisabled,
      },
      'separator',
      'copy',
      'copyWithHeaders',
    ];
    if (transferDisabled) {
      const disabled = {
        name:
          '<span style="display: flex; align-items: center; gap: 2px;"><svg style="width: 16px; height: 16px; fill: currentColor;" viewBox="0 0 24 24"><path d="M13 3c-4.97 0-9 4.03-9 9H1l3.89 3.89.07.14L9 12H6c0-3.87 3.13-7 7-7s7 3.13 7 7-3.13 7-7 7c-1.93 0-3.68-.79-4.94-2.06l-1.42 1.42C8.27 19.99 10.51 21 13 21c4.97 0 9-4.03 9-9s-4.03-9-9-9zm-1 5v5l4.28 2.54.72-1.21-3.5-2.08V8H12z"/></svg>Transfer disabled while group is pending</span>',
        disabled: false,
        action: () => {},
        cssClasses: [classes.nonSelectableOption],
      };
      options.unshift(disabled);
    }
    return options;
  };

  const calculateHeight = (size = 1) => {
    const sum = 1 - 0.2 * (size - 1);
    const height = (size + sum) * 38;
    return height > 272 ? '272px' : `${height}px`;
  };

  const createGroupSaveButtonClicked = async event => {
    event.preventDefault();
    seIsLoading(true);
    setCreateGroupSaveButtonDisabled(true);
    const { pricingActions, skyboxId, typeListing, groupsOpenned, index } = props;
    // eslint-disable-next-line prefer-destructuring
    const zones = store.getState().zones;
    const { selectedRows } = state;

    try {
      if (selectedRows.length > 0) {
        const newGroupListings = [];
        const newRows = rows2.filter((r, i) => {
          let flag = true;
          selectedRows.forEach(s => {
            if (s.rowIndex === i) {
              flag = false;
            }
          });
          if (!flag) {
            newGroupListings.push(r);
          }
          return flag;
        });
        const costPerUnit = parseFloat(newGroupListings[0].cost.replace('$', '') || 0);
        const isGreaterThanZero = costPerUnit > 0;
        const radix = 10;
        let floorPrice;

        if (isGreaterThanZero) {
          floorPrice = parseInt(costPerUnit * 1.1, radix);
          floorPrice += 0.99;
        } else {
          floorPrice = 20.99;
        }

        if (currGroupName && currGroupName !== '') {
          const groupData = [
            {
              skybox_event_id: skyboxId,
              ranks: newGroupListings.map((row, rankIndex) => ({
                rank: rankIndex,
                skybox_listing_id: row.skybox_listing_id,
                unit_cost: row.cost,
                include_exclude: [],
              })),
              exclude_obstructed_view: 1,
              name: currGroupName,
              ceiling: null,
              floor: floorPrice,
              increment: -0.5,
              increment_type: '%',
              spaceout: 5,
              spaceout_type: '%',
              splits: ['All'],
              auto_broadcast: 0,
            },
          ];
          const comps = {};
          comps.ticketnetwork = typeListing === 'ticketnetwork' ? currCompSections : [];
          comps.seatgeek = typeListing === 'seatgeek' ? currCompSections : [];
          await callbackUpdateListings(newRows, index, true);
          const newGroup = await pricingActionsImport.savePricingGroup(
            skyboxId,
            groupData,
            false,
            comps,
            zones,
            typeListing,
            false,
            null,
            null,
            true
          );
          const groupId = newGroup?.response[0]?.id;
          await store.dispatch(refreshGroups(skyboxId));
          store.dispatch(setGroupFocused(newGroup?.response[0]));
          pricingActions.setGroup(newGroup?.response[0]);
          pricingActions.setGroupEditingId(-1);
          if (newGroup?.response?.length) {
            pricingActions.setFocusedPricingGroupSection(groupId);
            if (groupsOpenned) {
              const newGroupsOppened = [...groupsOpenned];
              newGroupsOppened.push(groupId);
              store.dispatch(setGroupsOpenned(newGroupsOppened));
            }
          }
        }
      }
      seIsLoading(false);
      setCreateGroupSaveButtonDisabled(false);
      setIsModalOpen(false);
      setCurrGroupName('');
    } catch (error) {
      seIsLoading(false);
      setCreateGroupSaveButtonDisabled(false);
      setIsModalOpen(false);
      setCurrGroupName('');
    }
  };

  const createGroupCancelButtonClicked = () => {
    setIsModalOpen(false);
    setCurrGroupName('');
  };

  const createGroupNameInputChanged = event => {
    const newName = event.target.value;
    setCreateGroupSaveButtonDisabled(newName === EMPTY_STRING);
    setCurrGroupName(newName);
  };

  useEffect(() => {
    if (gridRef?.current) {
      if (props.isFocused) {
        const calculatedPrices = getCalculatedPrices();
        // eslint-disable-next-line no-underscore-dangle
        const _gridApi = gridRef.current.api;
        _gridApi.forEachNode(rowNode => {
          const sbId = _gridApi.getValue('skybox_id', rowNode);
          const calculatedPrice = Number(calculatedPrices[Number(sbId)] || 0).toFixed(2);
          rowNode.setDataValue('calculated_price', calculatedPrice);
        });
        _gridApi.refreshClientSideRowModel();
      } else {
        // eslint-disable-next-line no-underscore-dangle
        const _gridApi = gridRef.current.api;
        _gridApi.forEachNode(rowNode => {
          rowNode.setDataValue('calculated_price', '---');
        });
      }
    }
  }, [
    props.ranks,
    props.groupedListings,
    props.spaceout,
    props.spaceoutType,
    props.increment,
    props.incrementType,
    props.floor,
    props.ceiling,
    props.splits,
    props.currCompSections,
    props.currTNCompSections,
    props.manualPrice,
    props.isCompAllEvent,
    props.isCompAllGroup,
    props.hasDynamicSpaceout,
    props.dynamicSpaceoutEnabled,
    state,
    sortInfo,
  ]);

  const { statusBarPanels, rows, dataReady, openModal, getRowStyle } = state;
  const popupParent = useMemo(() => {
    return document.querySelector('body');
  }, []);

  useEffect(() => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }

    timeoutRef.current = setTimeout(() => {
      if (props.ranks && Array.isArray(initPosition) && initPosition.length === 0) {
        setInitPosition(props.ranks);
      }
      const data = createRows();
      setDataRows(data);
    }, DEBOUNCE_DELAY);
  }, [
    sortInfo,
    props.ranks,
    props.groupedListings,
    props.currCompSections,
    props.typeListing,
    filteredMarketplaceListings,
  ]);
  return (
    <React.Fragment>
      <div>
        <Card
          onClick={e => {
            e.stopPropagation();
          }}
        >
          {dataReady && (
            <div
              className={theme.palette.type === 'dark' ? 'ag-theme-balham-dark' : 'ag-theme-balham'}
              style={{
                boxSizing: 'border-box',
                width: '100%',
                minHeight: '80px',
                height: calculateHeight(rows?.length),
              }}
            >
              <AgGridReact
                ref={gridRef}
                onSelectionChanged={onSelectionChanged}
                columnDefs={getColumns()}
                rowData={dataRows}
                getRowStyle={getRowStyle}
                onGridReady={onGridReady}
                onSortChanged={e => {
                  if (!e.api.getSortModel()?.length) {
                    const sorting = { type: '', col: '' };
                    setState({ ...state, drag: false });
                    setSortInfo(sorting);
                    return;
                  }

                  const { colId, sort } = e.api.getSortModel()[0];
                  const sorting = { type: sort, col: colId };
                  setSortInfo(sorting);
                  const sortedRows = gridSort(rows, colId, sort);
                  updateState({ ...state, rows: sortedRows });
                  setState({ ...state, rows: sortedRows, drag: false });
                  setUpdateListingsOnSave(null);
                }}
                rowBuffer={0}
                rowSelection="multiple"
                rowDataChangeDetectionStrategy="IdentityCheck"
                animateRows={false}
                allowContextMenuWithControlKey
                getContextMenuItems={getContextMenuItems}
                statusBar={statusBarPanels}
                rowDragManaged
                onRowDragEnd={onRowDragEnd}
                onDragStopped={onDragStopped}
                masterDetail
                debug={false}
                popupParent={popupParent}
              />
            </div>
          )}
        </Card>
        <Modal
          aria-labelledby="Delete Group"
          aria-describedby="Modal for Delete a Group"
          open={openModal}
          onClose={handleModalClose}
        >
          <ModalContainer className={classes.paper}>
            <Typography variant="h6" id="modal-title" className={classes.modalText}>
              Are you sure you want to delete these Listings?
            </Typography>
            <form autoComplete="off" onSubmit={() => {}}>
              <div>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={e => {
                    deleteListingConfirmed(e);
                  }}
                  className={classes.button}
                >
                  Yes
                </Button>
                <Button
                  variant="contained"
                  onClick={e => {
                    handleModalClose(e);
                  }}
                  className={classes.button}
                >
                  No
                </Button>
              </div>
            </form>
          </ModalContainer>
        </Modal>
        <Modal aria-labelledby="Transfer" aria-describedby="Modal for transfer" open={showModal}>
          <ModalContainer className={classes.paper} style={{ minHeight: '176px', width: '517px', padding: '0px' }}>
            <ValidateUser />
            <Grid container direction="column">
              <Grid item xs={12} style={{ height: '40px', width: '517px' }}>
                <Typography
                  className={
                    theme.palette.type === 'dark'
                      ? classes.listingTransferModalDarkTheme
                      : classes.listingTransferModalLightTheme
                  }
                  style={{ padding: '10px 0px 10px 15px' }}
                >
                  Listing Transfer
                </Typography>
              </Grid>
              <Grid xs={12}>
                <div className={theme.palette.type === 'dark' ? classes.lineDarkTheme : classes.lineLightTheme}>
                  <></>
                </div>
              </Grid>
              <Grid item xs={12}>
                {/* eslint-disable */}
                <Typography style={{ fontSize: '14px', padding: '18px 15px 15px 15px' }}>
                  The selected listing will transfer from group&nbsp;
                  <strong>{groupName}</strong>
                  &nbsp;to&nbsp;<strong>{transferGroupName}</strong>, please confirm to proceed.
                </Typography>
                {/* eslint-disable */}
              </Grid>
              <Grid xs={12} style={{ paddingLeft: '15px', paddingRight: '15px' }}>
                <div className={theme.palette.type === 'dark' ? classes.lineTexDarkColor : classes.lineTexLightColor}>
                  <></>
                </div>
              </Grid>
              <Grid item xs={12}>
                <Grid
                  container
                  direction="row"
                  justifyContent="flex-end"
                  style={{ paddingRight: '17px', paddingBottom: '14px' }}
                >
                  <Grid item>
                    <Button
                      variant="outlined"
                      onClick={handleSubMenuModalClose}
                      className={
                        theme.palette.type === 'dark' ? classes.buttonTransfDarkTheme : classes.buttonTransfLightTheme
                      }
                    >
                      Cancel
                    </Button>
                  </Grid>
                  <Grid item style={{ paddingLeft: '15px' }}>
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={handleSubMenuModalConfirm}
                      className={
                        theme.palette.type === 'dark' ? classes.buttonTransfDarkTheme : classes.buttonTransfLightTheme
                      }
                      style={{ color: 'white' }}
                    >
                      Confirm
                    </Button>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </ModalContainer>
        </Modal>
      </div>
      <div style={{ zIndex: -1 }}>
        <NewGroupModal
          isModalOpen={isModalOpen}
          createGroupSaveButtonClicked={createGroupSaveButtonClicked}
          createGroupNameInputChanged={createGroupNameInputChanged}
          createGroupSaveButtonDisabled={createGroupSaveButtonDisabled}
          createGroupCancelButtonClicked={createGroupCancelButtonClicked}
          currGroupName={currGroupName}
          isLoading={isLoading}
        />
      </div>
    </React.Fragment>
  );
};

PricingGroupRanks.defaultProps = {
  manualPrice: null,
  focusedPricingGroup: null,
  marketplaces: null,
};

PricingGroupRanks.propTypes = {
  activeMarketplace: PropTypes.string.isRequired,
  ceiling: PropTypes.string.isRequired,
  currCompSections: PropTypes.array.isRequired,
  floor: PropTypes.number.isRequired,
  focusedPricingGroup: PropTypes.number,
  groupedListings: PropTypes.array.isRequired,
  groupName: PropTypes.string.isRequired,
  hashBroadcast: PropTypes.object.isRequired,
  increment: PropTypes.number.isRequired,
  incrementType: PropTypes.string.isRequired,
  index: PropTypes.number.isRequired,
  isAbTest: PropTypes.bool.isRequired,
  isCompAllEvent: PropTypes.bool.isRequired,
  isCompAllGroup: PropTypes.bool.isRequired,
  isFocused: PropTypes.bool.isRequired,
  isModalOpen: PropTypes.bool.isRequired,
  manualPrice: PropTypes.number,
  pricingGroup: PropTypes.object.isRequired,
  ranks: PropTypes.array.isRequired,
  settings: PropTypes.object.isRequired,
  setIsModalOpen: PropTypes.func.isRequired,
  spaceout: PropTypes.number.isRequired,
  spaceoutType: PropTypes.string.isRequired,
  setUpdateListingsOnSave: PropTypes.func.isRequired,
  pricingActions: PropTypes.object.isRequired,
  selectedInventoryRows: PropTypes.array.isRequired,
  skyboxId: PropTypes.string.isRequired,
  typeListing: PropTypes.string.isRequired,
  groupsOpenned: PropTypes.array.isRequired,
  marketplaces: PropTypes.object,
  filteredMarketplaceListings: PropTypes.array.isRequired,
  tmrMarkUpDown: PropTypes.number.isRequired,
  shMarkUpDown: PropTypes.number.isRequired,
  vsMarkUpDown: PropTypes.number.isRequired,
  showTMRListPrice: PropTypes.bool.isRequired,
  showSHListPrice: PropTypes.bool.isRequired,
  showVSListPrice: PropTypes.bool.isRequired,
};

function mapStateToProps(state) {
  return {
    activeMarketplace: state.globals.activeMarketplace,
    selectedInventoryRows: state.pricing.selectedInventoryRows,
    currCompSections: state.pricing.currTNComparisonSections,
    typeListing: state.pricing.focusedPricingGroupMarketplace,
    skyboxId: state.pricing.eventMeta.skybox_id,
    groupsOpenned: state.refreshGroupsInventory.groupsOpenned,
    isCompAllEvent: state.groupsStubhubSeatingState.isCompAllEvent,
    filteredMarketplaceListings: state.groupsStubhubState.filteredListings,
    showTMRListPrice: state.globals.showTMRListPrice,
    showSHListPrice: state.globals.showSHListPrice,
    showVSListPrice: state.globals.showVSListPrice,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    pricingActions: bindActionCreators(pricingActionsImport, dispatch),
    dispatch,
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(PricingGroupRanks);
